import { OpenAPI } from "simplydo/interfaces";

export const getCdnFile = (path: string) => {
  return `https://cdn.simplydo.co.uk/${path}`;
};

export const getImageUrl = (
  entity: any,
  fields: string[],
  sizes?: string[],
  defaultUrl?: string,
) => {
  if (entity && fields) {
    for (const field of fields) {
      if (sizes) {
        if (entity[field]) {
          if (entity[field].startsWith("unsplash-")) {
            const [w, h] = sizes[0].split("x");
            return entity[field].slice(9) + `&fit=min&w=${w}&h=${h}`;
          }
        }
        const thumbnailField = `${field}ThumbnailUrls`;
        if (entity[thumbnailField]) {
          for (const size of sizes) {
            if (entity[thumbnailField][size]) {
              return entity[thumbnailField][size];
            }
          }
        }
      }
      const regularField = `${field}Url`;
      if (entity[regularField]) {
        return entity[regularField];
      }
    }
  }
  return defaultUrl ? getCdnFile(defaultUrl) : null;
};

export const getThumbnail = (entity, field, size, defaultUrl) => {
  return getImageUrl(entity, [field], size ? [size] : undefined, defaultUrl);
};

export const challengeProfileLogo = (profile) => {
  const logoUrl = profile && profile.logoUrl;
  const logo = profile && profile.logo;
  return logoUrl || logo || getCdnFile("images/defaults/profile-logo.png");
};

export const userAvatarUrl = (
  user: OpenAPI.Schemas["User"],
  size = "100x100",
) => {
  const avatar = user && user.profile && user.profile.avatar;
  if (avatar && avatar.match(/^[0-9]+\.png/)) {
    return getCdnFile(`images/avatars/${avatar}`);
  }
  return getThumbnail(
    user?.profile,
    "avatar",
    size,
    "images/avatars/default.png",
  );
};

export const ideaCoverImage = (
  idea: OpenAPI.Schemas["Idea"],
  size = "200x200",
) => {
  return getThumbnail(idea, "coverImage", size, "images/idea.png");
};

export const challengeImage = (challenge: OpenAPI.Schemas["Challenge"]) => {
  return getImageUrl(
    challenge,
    ["coverImage", "bannerImage"],
    ["640x100", "300x300"],
    "images/challengeBanner.jpg",
  );
};

export const challengeBannerImage = (
  challenge: OpenAPI.Schemas["Challenge"],
) => {
  return getImageUrl(
    challenge,
    ["bannerImage"],
    ["640x100", "300x300"],
    "images/challengeBanner.jpg",
  );
};

export const groupCoverImage = (
  group: OpenAPI.Schemas["Group"],
  size = "200x200",
) => {
  return getThumbnail(group, "coverImage", size, "images/groupCoverImage.png");
};

export const groupBannerImage = (
  group: OpenAPI.Schemas["Group"],
  size = "200x200",
) => {
  return getThumbnail(group, "bannerImage", size, "images/groupBanner.jpg");
};
